import React, {createContext, useContext} from "react";
import {Auth} from "aws-amplify";
import {CoreContext} from '@genflow/core';
import {useAuth} from "../index";

export const AuthContext = createContext();
const isBrowser = typeof window !== `undefined`;

const AuthProvider = ({ children }) => {
    const config = useContext(CoreContext);
    const { vendorUuid } = config;
    const { useLogin, useIsLoggedIn, useRegister, useLogout } = useAuth();
    const { login, authenticating } = useLogin(true);
    const { register, registering } = useRegister(true);
    const authenticated = useIsLoggedIn(true);
    const logout = useLogout(true);

    const getUserName = (email) => `${email.toLowerCase()}#${vendorUuid}`;
    const getUser = async () => {
        if (isBrowser) {
            try {
                const user = await Auth.currentAuthenticatedUser();
                return user;
            } catch (e) {
                console.log('Error getting user...', e);
                return null;
            }
        }
    };

    // Also a nice way to check if the user is authenticated
    const getToken = async () => {
        if (isBrowser) {
            try {
                const session = await Auth.currentSession();
                const token = session?.getIdToken()?.getJwtToken();
                return token;
            } catch (e) {
                console.log('Error getting token...', e);
                return null;
            }
        }
    };

    return (
        <AuthContext.Provider value={{
            authenticated, authenticating, registering,
            register, login, logout, getUserName, getToken, getUser,
        }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthProvider;
